import CommonRawHtml from 'common/components/entities/RawHtmlNew/RawHtml'
import { RawHtmlInterface } from 'common/types/entities/RawHtmlInterface'
import React from 'react'
import { EntityProps } from '../../../types'
import BaseEntityNew from '../../core/BaseEntity/BaseEntityNew'
import NewRawHtmlWatermarkUi from './ui/NewRawHtmlWatermarkUi'

function NewRawHtml({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<RawHtmlInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <NewRawHtmlWatermarkUi data-watermark="HTML">
        <CommonRawHtml
          html={entity.html}
          htmlAttrId={entity.htmlAttrId}
          textAlign={entity.textAlign}
          mobileTextAlign={entity.mobileTextAlign}
        />
      </NewRawHtmlWatermarkUi>
    </BaseEntityNew>
  )
}

export default NewRawHtml
